import { useState } from "react";

interface ScoreBreakdownBarProps {
  social: number | null;
  backers: number | null;
  pedigree: number | null;
  momentum: number | null;
  dev: number | null;
  revenue: number | null;
}

const SEGMENTS: { key: keyof ScoreBreakdownBarProps; label: string; color: string; max: number }[] =
  [
    { key: "backers", label: "Backers", color: "#8b5cf6", max: 25 },
    { key: "momentum", label: "Momentum", color: "#10b981", max: 25 },
    { key: "social", label: "Social", color: "#3b82f6", max: 20 },
    { key: "pedigree", label: "Pedigree", color: "#f59e0b", max: 20 },
    { key: "dev", label: "Dev", color: "#06b6d4", max: 5 },
    { key: "revenue", label: "Revenue", color: "#ec4899", max: 5 },
  ];

export function ScoreBreakdownBar(props: ScoreBreakdownBarProps) {
  const [showPopover, setShowPopover] = useState(false);
  const total = SEGMENTS.reduce((s, seg) => s + (Number(props[seg.key]) || 0), 0);
  if (total === 0) return <div className="td-breakdown-bar td-breakdown-empty" />;

  return (
    <div
      className="td-breakdown-wrap"
      role="tooltip"
      onMouseEnter={() => setShowPopover(true)}
      onMouseLeave={() => setShowPopover(false)}
    >
      <div className="td-breakdown-bar">
        {SEGMENTS.map((seg) => {
          const val = Number(props[seg.key]) || 0;
          if (val <= 0) return null;
          const pct = (val / 100) * 100;
          return (
            <div
              key={seg.key}
              className="td-breakdown-segment"
              style={{ width: `${pct}%`, backgroundColor: seg.color }}
            />
          );
        })}
      </div>
      {showPopover && (
        <div className="td-breakdown-popover">
          <div className="td-breakdown-popover-total">
            <span>Total</span>
            <span>{total.toFixed(1)}</span>
          </div>
          {SEGMENTS.map((seg) => {
            const val = Number(props[seg.key]) || 0;
            return (
              <div key={seg.key} className="td-breakdown-popover-row">
                <span className="td-breakdown-popover-dot" style={{ backgroundColor: seg.color }} />
                <span className="td-breakdown-popover-label">{seg.label}</span>
                <span className="td-breakdown-popover-val">{val.toFixed(1)}</span>
                <span className="td-breakdown-popover-max">/ {seg.max}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
